"use client";

import { c as _c } from "react/compiler-runtime";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import { startDropOpen } from "@/utils/monitoring/dropOpenTiming";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { WaveLeaderboardDropContent } from "../content/WaveLeaderboardDropContent";
import { WaveLeaderboardDropFooter } from "./footer/WaveLeaderboardDropFooter";
import { WaveLeaderboardDropHeader } from "./header/WaveLeaderboardDropHeader";
import { WaveLeaderboardDropRaters } from "./header/WaveleaderboardDropRaters";
interface DefaultWaveLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const DefaultWaveLeaderboardDrop: React.FC<DefaultWaveLeaderboardDropProps> = t0 => {
  const $ = _c(56);
  const {
    drop,
    onDropClick
  } = t0;
  const {
    canShowVote,
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== hasTouchScreen) {
    t1 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t1);
  let t2;
  if ($[2] !== drop.rank) {
    t2 = () => {
      const rank = drop.rank && drop.rank <= 3 ? drop.rank : "default";
      if (rank === 1) {
        return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-[#fbbf24]/40";
      } else {
        if (rank === 2) {
          return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-[#94a3b8]/40";
        } else {
          if (rank === 3) {
            return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-[#CD7F32]/40";
          } else {
            return "tw-rounded-xl tw-bg-iron-950 tw-p-4 md:tw-px-5 tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-200 tw-ease-out tw-overflow-hidden desktop-hover:hover:tw-border-iron-700";
          }
        }
      }
    };
    $[2] = drop.rank;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getBorderClasses = t2;
  let t3;
  if ($[4] !== drop || $[5] !== isMobileScreen || $[6] !== onDropClick) {
    t3 = () => {
      startDropOpen({
        dropId: drop.id,
        waveId: drop.wave.id,
        source: "leaderboard_list",
        isMobile: isMobileScreen
      });
      onDropClick(drop);
    };
    $[4] = drop;
    $[5] = isMobileScreen;
    $[6] = onDropClick;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = getBorderClasses();
  let t5;
  if ($[8] !== drop) {
    t5 = <WaveLeaderboardDropHeader drop={drop} />;
    $[8] = drop;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== drop) {
    t6 = <div className="tw-hidden tw-h-8 lg:tw-block"><WaveDropActionsOpen drop={drop} /></div>;
    $[10] = drop;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== canDelete || $[13] !== drop) {
    t7 = canDelete && <WaveDropActionsOptions drop={drop} />;
    $[12] = canDelete;
    $[13] = drop;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <div className="tw-hidden tw-h-8 lg:tw-block">{t7}</div>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="tw-flex tw-items-center">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t9) {
    t10 = <div className="tw-flex tw-flex-col tw-gap-3"><div className="tw-flex tw-items-center tw-justify-between tw-gap-4">{t5}{t9}</div></div>;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== drop) {
    t11 = <div className="tw-space-y-2"><div className="tw-ml-[3.35rem]"><WaveLeaderboardDropContent drop={drop} isCompetitionDrop={true} /></div></div>;
    $[23] = drop;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== drop) {
    t12 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2"><WaveLeaderboardDropRaters drop={drop} /><WaveLeaderboardDropFooter drop={drop} /></div>;
    $[25] = drop;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== canShowVote || $[28] !== drop) {
    t13 = canShowVote && <div className="tw-flex tw-justify-center tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-border-t-0 @[700px]:tw-pt-0" onClick={_temp}><VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} /></div>;
    $[27] = canShowVote;
    $[28] = drop;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className="tw-mt-3 tw-inline-flex tw-flex-col tw-justify-between tw-gap-x-2 tw-space-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-space-y-0 sm:tw-ml-[3.25rem]">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t10 || $[34] !== t11 || $[35] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-3">{t10}{t11}{t14}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t15 || $[38] !== t4 || $[39] !== touchHandlers) {
    t16 = <div className={t4} {...touchHandlers}>{t15}</div>;
    $[37] = t15;
    $[38] = t4;
    $[39] = touchHandlers;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== drop || $[42] !== isMobileScreen || $[43] !== isVotingModalOpen) {
    t17 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[41] = drop;
    $[42] = isMobileScreen;
    $[43] = isVotingModalOpen;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] !== canDelete || $[46] !== drop || $[47] !== hasTouchScreen || $[48] !== isActive || $[49] !== setIsActive) {
    t18 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[45] = canDelete;
    $[46] = drop;
    $[47] = hasTouchScreen;
    $[48] = isActive;
    $[49] = setIsActive;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t16 || $[52] !== t17 || $[53] !== t18 || $[54] !== t3) {
    t19 = <div onClick={t3} className="tw-group tw-relative tw-w-full tw-cursor-pointer tw-rounded-xl tw-transition tw-duration-300 tw-ease-out tw-@container">{t16}{t17}{t18}</div>;
    $[51] = t16;
    $[52] = t17;
    $[53] = t18;
    $[54] = t3;
    $[55] = t19;
  } else {
    t19 = $[55];
  }
  return t19;
};
function _temp(e) {
  return e.stopPropagation();
}